var _defs, _g, _g2, _g3, _g4, _g5, _g6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeroImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #036;\n      }\n\n      .st1, .st2, .st3 {\n        opacity: .1;\n      }\n\n      .st1, .st3 {\n        isolation: isolate;\n      }\n\n      .st4 {\n        fill: #ebebeb;\n      }\n\n      .st5 {\n        fill: #dbdbdb;\n      }\n\n      .st6 {\n        fill: #37474f;\n      }\n\n      .st7 {\n        fill: #263238;\n      }\n\n      .st8 {\n        fill: #c7c7c7;\n      }\n\n      .st9 {\n        fill: #a6a6a6;\n      }\n\n      .st10 {\n        fill: #fff;\n      }\n\n      .st11 {\n        fill: #f60;\n      }\n\n      .st12 {\n        fill: #455a64;\n      }\n\n      .st3 {\n        fill: #020100;\n      }\n\n      .st13 {\n        fill: #d3766a;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M39,267.5l13.1-.3h6.7c2.2-.2,4.5-.1,6.7-.2h.4v11.6c0,0,0,.5,0,.5h-13.7c-4.4,0-8.8-.2-13.2-.2h-.3v-.3c0-1.9,0-3.8.1-5.6v-5.6ZM39,267.5v5.6c.1,1.9.2,3.7.3,5.5l-.3-.3c4.4,0,8.8-.2,13.2-.2h13.2c0,0-.5.4-.5.4v-11.2l.4.5c-2.2,0-4.4,0-6.5,0h-6.6c0-.1-13.3-.4-13.3-.4Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    x: 287.6,
    y: 170.1,
    width: 26.5,
    height: 11.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M302.4,156l13.1-.3h6.7c2.2-.2,4.5-.1,6.7-.2h.4v11.6s0,.5,0,.5h-13.8c-4.4,0-8.8-.2-13.2-.2h-.3v-.3c0-1.9,0-3.8.1-5.7v-5.5ZM302.4,156v5.6c.1,1.9.3,3.7.3,5.5l-.3-.3c4.4,0,8.8-.2,13.2-.2h13.2c0,0-.5.4-.5.4v-11.2s.5.4.5.4h-13.1c0-.1-13.4-.4-13.4-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M272.9,156l13.1-.3h6.7c2.2-.2,4.5-.1,6.7-.2h.5v11.6s0,.5,0,.5h-13.7c-4.4,0-8.8-.2-13.2-.2h-.3v-.3c0-1.9,0-3.8.1-5.7v-5.5ZM272.9,156v5.6c.2,1.9.3,3.7.3,5.5l-.3-.3c4.4,0,8.8-.2,13.2-.2h13.2c0,0-.5.4-.5.4v-11.2c0,0,.5.4.5.4h-13.1c0-.1-13.4-.4-13.4-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M446.3,59.9l-13.1.3h-6.7c-2.2.2-4.5.1-6.7.2h-.4v-11.6c0,0,0-.5,0-.5h13.7c4.4,0,8.8.2,13.2.2h.3v.3c0,1.9,0,3.8-.1,5.7v5.5ZM446.3,59.9v-5.7c-.1-1.9-.2-3.7-.3-5.5l.3.3c-4.4,0-8.8.2-13.2.2h-13.2c0,0,.5-.4.5-.4v11.2s-.5-.4-.5-.4h13.1c0,.1,13.4.4,13.4.4Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    x: 434.6,
    y: 62.9,
    width: 26.5,
    height: 11.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M65.4,60l-13.1.3h-6.7c-2.2.1-4.5.1-6.7.1h-.5v-12.1h13.7c4.4,0,8.8.2,13.2.2h.3v.3c0,1.9,0,3.8-.1,5.7l-.2,5.6ZM65.4,60l-.2-5.7c0-1.9-.1-3.7-.1-5.5l.3.3c-4.4,0-8.8.2-13.2.2h-13.2s.5-.5.5-.5v11.2c0,0-.5-.5-.5-.5,2.2,0,4.3,0,6.5,0h6.6c0,.1,13.3.4,13.3.4Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    x: 338,
    y: 345.8,
    width: 26.5,
    height: 11.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M434.6,271.7l13.1-.3h6.7c2.2-.2,4.5-.1,6.7-.2h.5v11.6s0,.5,0,.5h-13.8c-4.4,0-8.8-.2-13.2-.2h-.3v-.3c0-1.9,0-3.8.1-5.6l.2-5.5ZM434.6,271.7v5.6c.1,1.9.3,3.7.3,5.5l-.3-.3c4.4,0,8.8-.2,13.2-.2h13.2c0,0-.5.4-.5.4v-11.2s.5.5.5.5c-2.2,0-4.4,0-6.5,0h-6.6c0-.1-13.4-.4-13.4-.4Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    x: 122.8,
    y: 401.6,
    width: 26.5,
    height: 11.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M352.7,331.7l13.1-.3h6.7c2.2-.1,4.5-.1,6.7-.2h.4v12.1h-13.7c-4.4,0-8.8-.2-13.2-.2h-.3v-.3c0-1.9,0-3.8.1-5.6v-5.6ZM352.7,331.7v5.7c.2,1.9.2,3.7.3,5.5l-.3-.3c4.4,0,8.8-.2,13.2-.2h13.2c0,0-.5.4-.5.4v-11.2s.5.5.5.5c-2.2,0-4.4,0-6.5,0h-6.6c0-.1-13.4-.4-13.4-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M55,156.2c1.2-.7,2.7-.7,3.9,0,.3.2.7.4,1,.6s.7.4,1,.5c1.3.6,2.1,1.8,2.2,3.2l.2,4.8,15.7-.5v-4.9c-.2-1.4.6-2.7,1.9-3.4.7-.4,1.4-.8,2-1.2,1.2-.8,2.7-.9,3.9-.3l4.2,2.3,7.4-13.9-4.2-2.3c-1.3-.7-2-2-2-3.4,0-.8,0-1.5,0-2.3-.1-1.4.5-2.8,1.7-3.5l4.2-2.6-8.3-13.4-4.1,2.6c-1.2.7-2.7.7-3.8,0-.3-.2-.7-.4-1.1-.6s-.7-.4-1.1-.6c-1.3-.6-2.1-1.8-2.1-3.2l-.2-4.8-15.7.5.2,4.8c0,1.4-.7,2.7-1.9,3.4-.7.4-1.4.8-2.1,1.3-1.1.8-2.6.9-3.8.2l-4.2-2.3-7.4,13.9,4.2,2.3c1.3.7,2,2,2,3.4,0,.8,0,1.5,0,2.3.1,1.4-.5,2.8-1.7,3.5l-4.1,2.6,8.3,13.4,4.1-2.6ZM58.2,132.9c2.5-6.7,9.9-10,16.6-7.5,6.7,2.5,10,9.9,7.5,16.6-2.5,6.7-9.9,10-16.6,7.5-1.1-.4-2.1-.9-3-1.6-4.7-3.4-6.6-9.5-4.6-15h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M457.9,246.6l-5.5-9.6-2.9,1.7c-.9.5-1.9.5-2.8,0-.5-.3-.9-.6-1.4-.8-.9-.4-1.4-1.3-1.5-2.3v-3.4h-11v3.4c0,1-.6,1.9-1.5,2.3-.5.2-1,.5-1.4.8-.8.5-1.9.6-2.8,0l-2.9-1.7-5.5,9.6,2.9,1.7c.9.5,1.4,1.4,1.3,2.4v1.6c0,1-.4,1.9-1.3,2.4l-2.9,1.7,5.5,9.5,2.9-1.7c.9-.5,1.9-.5,2.7.1.5.3.9.6,1.4.8.9.4,1.4,1.3,1.4,2.3v3.4h11v-3.4c0-1,.6-1.9,1.4-2.3.5-.2,1-.5,1.4-.8.8-.5,1.9-.6,2.7-.1l2.9,1.7,5.5-9.5-2.9-1.7c-.9-.5-1.3-1.4-1.3-2.4v-1.6c0-1,.4-1.9,1.3-2.4l2.9-1.7ZM447.3,251.6c0,5-4,9-9,9s-9-4-9-9,4-9,9-9h0c5,0,9,4,9,9h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M153.8,63.8l-5.5-9.5-2.9,1.7c-.9.5-1.9.5-2.8,0-.5-.3-.9-.6-1.4-.8-.9-.4-1.4-1.3-1.4-2.3v-3.4h-11v3.4c0,1-.6,1.9-1.4,2.3-.5.3-1,.5-1.4.8-.8.5-1.9.6-2.8,0l-2.9-1.7-5.5,9.5,2.9,1.7c.9.5,1.3,1.5,1.3,2.5v1.6c0,1-.4,1.9-1.3,2.4l-2.9,1.7,5.5,9.6,2.9-1.7c.9-.5,1.9-.5,2.7,0,.5.3.9.6,1.4.8.9.4,1.4,1.3,1.4,2.3v3.4h11v-3.4c0-1,.6-1.9,1.4-2.3.5-.2,1-.5,1.4-.8.8-.6,1.9-.6,2.7,0l2.9,1.7,5.5-9.6-2.9-1.7c-.9-.5-1.3-1.4-1.3-2.4v-1.6c0-1,.4-1.9,1.3-2.4l2.9-1.7ZM143.2,68.8c0,5-4,9-9,9s-9-4-9-9,4-9,9-9,9,4,9,9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M83.1,274v170.7h103.2v-170.7h-103.2ZM92.5,337.3h84.5v44.4h-84.5v-44.4ZM92.5,282.3h84.5v44.4h-84.5v-44.4Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    x: 36.4,
    y: 274,
    width: 46.7,
    height: 170.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    x: 156.8,
    y: 282.2,
    width: 20.1,
    height: 44.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M176.6,434.2h-84.4v-42.9h84.4v42.9ZM92.7,433.7h83.4v-41.9h-83.4v41.9Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    x: 126.1,
    y: 403.5,
    width: 16.7,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    x: 156.8,
    y: 337.2,
    width: 20.1,
    height: 44.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st9",
    x: 104,
    y: 340.7,
    width: 14.1,
    height: 41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st5",
    x: 104,
    y: 366.3,
    width: 14.1,
    height: 8.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st5",
    x: 104,
    y: 353.9,
    width: 14.1,
    height: 5.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    x: 75.4,
    y: 239.7,
    width: 35.7,
    height: 34.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st8",
    x: 61.9,
    y: 239.7,
    width: 13.6,
    height: 34.3
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "111.1 256.8 75.4 256.8 103.3 257.7 111.1 256.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "75.4 269.8 111.1 269.8 83.2 270.7 75.4 269.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "111.1 247.2 88.5 247.2 108.6 247.9 111.1 247.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "75.4 264.8 98 264.8 77.9 265.5 75.4 264.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "102.6 243.4 77.1 243.4 81.3 243.8 102.6 243.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "107.6 260.5 82.2 260.5 86.4 260.9 107.6 260.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "92 250.5 75.4 250.5 72.5 251.6 92 250.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "115.7 250.5 99.1 250.5 96.2 251.6 115.7 250.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "94.4 265.9 111 265.9 113.9 267 94.4 265.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "75.4 262 62.2 262 59.2 263.1 75.4 262"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "70.8 256.8 60.5 256.8 61.9 255.9 70.8 256.8"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    x: 116.6,
    y: 292.4,
    width: 35.7,
    height: 34.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st8",
    x: 103,
    y: 292.4,
    width: 13.6,
    height: 34.3
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "152.3 309.5 116.6 309.5 144.5 310.4 152.3 309.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "116.6 322.5 152.3 322.5 124.4 323.4 116.6 322.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "152.3 299.9 129.7 299.9 149.8 300.7 152.3 299.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "116.6 317.5 139.2 317.5 119.1 318.2 116.6 317.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "143.7 296.1 118.2 296.1 122.5 296.6 143.7 296.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "148.8 313.2 123.3 313.2 127.6 313.6 148.8 313.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "133.1 303.2 116.6 303.2 113.7 304.4 133.1 303.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "156.8 303.2 140.3 303.2 137.4 304.4 156.8 303.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "135.6 318.6 152.2 318.6 155.1 319.8 135.6 318.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "116.6 314.7 103.3 314.7 100.4 315.9 116.6 314.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "112 309.5 101.7 309.5 103 308.6 112 309.5"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    x: 92.4,
    y: 338,
    width: 11.6,
    height: 43.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M98.2,346.6c1.3,0,2.4-1.1,2.4-2.4,0-1.3-1.1-2.4-2.4-2.4-1.3,0-2.4,1.1-2.4,2.4,0,0,0,0,0,0,0,1.3,1.1,2.4,2.4,2.4,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M98.2,345.6c.8,0,1.4-.6,1.4-1.4s-.6-1.4-1.4-1.4c-.8,0-1.4.6-1.4,1.4,0,0,0,0,0,0,0,.8.6,1.4,1.4,1.4s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st10",
    x: 92.5,
    y: 364.2,
    width: 11.5,
    height: 10.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st8",
    x: 118.1,
    y: 372.7,
    width: 43.7,
    height: 9.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M126.8,377.2c0-1.3-1.1-2.4-2.4-2.4s-2.4,1.1-2.4,2.4c0,1.3,1.1,2.4,2.4,2.4,0,0,0,0,0,0,1.3,0,2.4-1.1,2.4-2.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M125.7,377.2c0-.8-.5-1.4-1.3-1.5-.8,0-1.4.5-1.5,1.3,0,0,0,.2,0,.2,0,.8.7,1.3,1.5,1.3.7,0,1.2-.6,1.3-1.3Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st10",
    x: 144.3,
    y: 372.7,
    width: 10.6,
    height: 9.1
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "267.4 103.4 317.8 77 298.3 42.8 247.9 69.2 267.4 103.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "278.5 48.6 296.3 39.3 298.3 42.8 279.5 52.7 278.5 48.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "267.5 103.3 317.8 76.9 303.3 43.8 252.9 70.3 267.5 103.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "284 49.8 301.8 40.4 303.3 43.8 284.5 53.7 284 49.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "300.9 116.3 369.5 104.7 359.7 57.6 291.1 69.2 300.9 116.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "334.5 56.8 358.7 52.7 359.7 57.6 334.1 61.9 334.5 56.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "301 116.3 369.5 104.7 365.1 60.7 296.6 72.3 301 116.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "340.5 60.2 364.7 56.1 365.1 60.7 339.5 65 340.5 60.2"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-18"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "36.4 444.7 89.8 444.4 143.2 444.4 250 444.2 356.8 444.4 410.2 444.4 463.6 444.7 410.2 444.9 356.8 445 250 445.2 143.2 445 89.8 444.9 36.4 444.7"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Cloud--inject-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M328.2,111c0,8.6,6.6,15.7,15.2,16.4h93c10.7,0,19.3-8.6,19.4-19.2,0-10-7.6-18.4-17.5-19.3-.6-17.9-15.7-32-33.6-31.4-13.2.4-24.8,8.8-29.4,21.2-9.5-4.8-21.1-.9-25.9,8.6-1.2,2.3-1.8,4.9-2,7.4-.9-.1-1.8-.2-2.7-.2-9.1,0-16.4,7.4-16.5,16.4,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M328.2,111c0,8.6,6.6,15.7,15.2,16.4h93c10.7,0,19.3-8.6,19.4-19.2,0-10-7.6-18.4-17.5-19.3-.6-17.9-15.7-32-33.6-31.4-13.2.4-24.8,8.8-29.4,21.2-9.5-4.8-21.1-.9-25.9,8.6-1.2,2.3-1.8,4.9-2,7.4-.9-.1-1.8-.2-2.7-.2-9.1,0-16.4,7.4-16.5,16.4,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M318.9,111c0,8.6,6.6,15.7,15.2,16.4h93c10.7,0,19.3-8.6,19.3-19.3,0-10-7.6-18.4-17.5-19.3-.6-17.9-15.7-32-33.6-31.4-13.2.4-24.8,8.8-29.4,21.2-2.7-1.3-5.6-2-8.6-2-10.2,0-18.6,7.9-19.3,18.1-.9-.1-1.8-.2-2.7-.2-9.1,0-16.4,7.4-16.4,16.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M376.2,127.4h22.1v17.7c0,2.5-2,4.5-4.5,4.5h-13.2c-2.5,0-4.5-2-4.5-4.5v-17.7h0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st12",
    x: 382.1,
    y: 149.6,
    width: 10.5,
    height: 3.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M385.4,142.1c0,1.1-.9,2-2,2s-2-.9-2-2,.9-2,2-2,2,.9,2,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M393.2,142.1c0,1.1-.9,2-2,2s-2-.9-2-2,.9-2,2-2,2,.9,2,2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "388.4 130.6 386 134.2 387.2 134.2 386 137.2 388.6 133.6 387.3 133.6 388.4 130.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M382.7,311.3h-34.7v-3h34.6c1.7,0,3.1-1.4,3.1-3.1h0v-152.4h3v152.4c0,3.4-2.7,6.1-6.1,6.1Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Server--inject-18"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st7",
    x: 164.6,
    y: 198.9,
    width: 65.2,
    height: 245.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 229.8,
    y: 198.9,
    width: 120,
    height: 245.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st6",
    x: 238.8,
    y: 412.8,
    width: 103.5,
    height: 23.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st12",
    x: 243.1,
    y: 416.8,
    width: 58.9,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st12",
    x: 243.1,
    y: 420.2,
    width: 58.9,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st12",
    x: 243.1,
    y: 423.8,
    width: 58.9,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st12",
    x: 243.1,
    y: 427.2,
    width: 58.9,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st12",
    x: 243.1,
    y: 430.7,
    width: 58.9,
    height: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st11",
    cx: 310.7,
    cy: 418.8,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M319.3,418.8c0,1.1-.9,2-2,2s-2-.9-2-2,.9-2,2-2,2,.9,2,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M325.9,418.8c0,1.1-.9,2-2,2s-2-.9-2-2,.9-2,2-2,2,.9,2,2Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 330.5,
    cy: 418.8,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M339.1,418.8c0,1.1-.9,2-2,2s-2-.9-2-2,.9-2,2-2,2,.9,2,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M312.7,424.8c0,1.1-.9,2-2,2s-2-.9-2-2,.9-2,2-2,2,.9,2,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M319.3,424.8c0,1.1-.9,2-2,2s-2-.9-2-2,.9-2,2-2,2,.9,2,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M325.9,424.8c0,1.1-.9,2-2,2s-2-.9-2-2,.9-2,2-2,2,.9,2,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M332.5,424.8c0,1.1-.9,2-2,2s-2-.9-2-2,.9-2,2-2,2,.9,2,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M339.1,424.8c0,1.1-.9,2-2,2s-2-.9-2-2,.9-2,2-2,2,.9,2,2Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st11",
    cx: 310.7,
    cy: 430.8,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M319.3,430.8c0,1.1-.9,2-2,2s-2-.9-2-2,.9-2,2-2,2,.9,2,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M325.9,430.8c0,1.1-.9,2-2,2s-2-.9-2-2,.9-2,2-2,2,.9,2,2Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st11",
    cx: 330.5,
    cy: 430.8,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M339.1,430.8c0,1.1-.9,2-2,2s-2-.9-2-2,.9-2,2-2,2,.9,2,2Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st7",
    x: 304.9,
    y: 416.8,
    width: 1.1,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st6",
    x: 238.8,
    y: 384,
    width: 103.5,
    height: 23.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st12",
    x: 243.1,
    y: 388,
    width: 58.9,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st12",
    x: 243.1,
    y: 391.5,
    width: 58.9,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st12",
    x: 243.1,
    y: 395,
    width: 58.9,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st12",
    x: 243.1,
    y: 398.5,
    width: 58.9,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st12",
    x: 243.1,
    y: 401.9,
    width: 58.9,
    height: 2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M312.7,390c0,1.1-.9,2-2,2s-2-.9-2-2,.9-2,2-2,2,.9,2,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M319.3,390c0,1.1-.9,2-2,2s-2-.9-2-2,.9-2,2-2,2,.9,2,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M325.9,390c0,1.1-.9,2-2,2s-2-.9-2-2,.9-2,2-2,2,.9,2,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M332.5,390c0,1.1-.9,2-2,2s-2-.9-2-2,.9-2,2-2,2,.9,2,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M339.1,390c0,1.1-.9,2-2,2s-2-.9-2-2,.9-2,2-2,2,.9,2,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M312.7,396c0,1.1-.9,2-2,2s-2-.9-2-2,.9-2,2-2,2,.9,2,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M319.3,396c0,1.1-.9,2-2,2s-2-.9-2-2,.9-2,2-2,2,.9,2,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M325.9,396c0,1.1-.9,2-2,2s-2-.9-2-2,.9-2,2-2,2,.9,2,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M332.5,396c0,1.1-.9,2-2,2s-2-.9-2-2,.9-2,2-2,2,.9,2,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M339.1,396c0,1.1-.9,2-2,2s-2-.9-2-2,.9-2,2-2,2,.9,2,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M312.7,402c0,1.1-.9,2-2,2s-2-.9-2-2,.9-2,2-2,2,.9,2,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M319.3,402c0,1.1-.9,2-2,2s-2-.9-2-2,.9-2,2-2,2,.9,2,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M325.9,402c0,1.1-.9,2-2,2s-2-.9-2-2,.9-2,2-2,2,.9,2,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M332.5,402c0,1.1-.9,2-2,2s-2-.9-2-2,.9-2,2-2,2,.9,2,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M339.1,402c0,1.1-.9,2-2,2s-2-.9-2-2,.9-2,2-2,2,.9,2,2Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st7",
    x: 304.9,
    y: 388,
    width: 1.1,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st6",
    x: 238.8,
    y: 355.2,
    width: 103.5,
    height: 23.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st12",
    x: 243.1,
    y: 359.2,
    width: 58.9,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st12",
    x: 243.1,
    y: 362.7,
    width: 58.9,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st12",
    x: 243.1,
    y: 366.1,
    width: 58.9,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st12",
    x: 243.1,
    y: 369.6,
    width: 58.9,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st12",
    x: 243.1,
    y: 373.1,
    width: 58.9,
    height: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 310.7,
    cy: 361.2,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M319.3,361.2c0,1.1-.9,2-2,2s-2-.9-2-2,.9-2,2-2,2,.9,2,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M325.9,361.2c0,1.1-.9,2-2,2s-2-.9-2-2,.9-2,2-2,2,.9,2,2Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st11",
    cx: 330.5,
    cy: 361.2,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M339.1,361.2c0,1.1-.9,2-2,2s-2-.9-2-2,.9-2,2-2,2,.9,2,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M312.7,367.2c0,1.1-.9,2-2,2s-2-.9-2-2,.9-2,2-2,2,.9,2,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M319.3,367.2c0,1.1-.9,2-2,2s-2-.9-2-2,.9-2,2-2,2,.9,2,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M325.9,367.2c0,1.1-.9,2-2,2s-2-.9-2-2,.9-2,2-2,2,.9,2,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M332.5,367.2c0,1.1-.9,2-2,2s-2-.9-2-2,.9-2,2-2,2,.9,2,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M339.1,367.2c0,1.1-.9,2-2,2s-2-.9-2-2,.9-2,2-2,2,.9,2,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M312.7,373.2c0,1.1-.9,2-2,2s-2-.9-2-2,.9-2,2-2,2,.9,2,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M319.3,373.2c0,1.1-.9,2-2,2s-2-.9-2-2,.9-2,2-2,2,.9,2,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M325.9,373.2c0,1.1-.9,2-2,2s-2-.9-2-2,.9-2,2-2,2,.9,2,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M332.5,373.2c0,1.1-.9,2-2,2s-2-.9-2-2,.9-2,2-2,2,.9,2,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M339.1,373.2c0,1.1-.9,2-2,2s-2-.9-2-2,.9-2,2-2,2,.9,2,2Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st7",
    x: 304.9,
    y: 359.2,
    width: 1.1,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st6",
    x: 238.8,
    y: 326.4,
    width: 103.5,
    height: 23.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st12",
    x: 243.1,
    y: 330.4,
    width: 58.9,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st12",
    x: 243.1,
    y: 333.9,
    width: 58.9,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st12",
    x: 243.1,
    y: 337.4,
    width: 58.9,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st12",
    x: 243.1,
    y: 340.9,
    width: 58.9,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st12",
    x: 243.1,
    y: 344.4,
    width: 58.9,
    height: 2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M312.7,332.4c0,1.1-.9,2-2,2s-2-.9-2-2,.9-2,2-2,2,.9,2,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M319.3,332.4c0,1.1-.9,2-2,2s-2-.9-2-2,.9-2,2-2,2,.9,2,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M325.9,332.4c0,1.1-.9,2-2,2s-2-.9-2-2,.9-2,2-2,2,.9,2,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M332.5,332.4c0,1.1-.9,2-2,2s-2-.9-2-2,.9-2,2-2,2,.9,2,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M339.1,332.4c0,1.1-.9,2-2,2s-2-.9-2-2,.9-2,2-2,2,.9,2,2Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 310.7,
    cy: 338.4,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M319.3,338.4c0,1.1-.9,2-2,2s-2-.9-2-2,.9-2,2-2,2,.9,2,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M325.9,338.4c0,1.1-.9,2-2,2s-2-.9-2-2,.9-2,2-2,2,.9,2,2Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 330.5,
    cy: 338.4,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M339.1,338.4c0,1.1-.9,2-2,2s-2-.9-2-2,.9-2,2-2,2,.9,2,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M312.7,344.4c0,1.1-.9,2-2,2s-2-.9-2-2,.9-2,2-2,2,.9,2,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M319.3,344.4c0,1.1-.9,2-2,2s-2-.9-2-2,.9-2,2-2,2,.9,2,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M325.9,344.4c0,1.1-.9,2-2,2s-2-.9-2-2,.9-2,2-2,2,.9,2,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M332.5,344.4c0,1.1-.9,2-2,2s-2-.9-2-2,.9-2,2-2,2,.9,2,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M339.1,344.4c0,1.1-.9,2-2,2s-2-.9-2-2,.9-2,2-2,2,.9,2,2Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st7",
    x: 304.9,
    y: 330.4,
    width: 1.1,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st6",
    x: 238.8,
    y: 297.6,
    width: 103.5,
    height: 23.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st12",
    x: 243.1,
    y: 301.6,
    width: 58.9,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st12",
    x: 243.1,
    y: 305.1,
    width: 58.9,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st12",
    x: 243.1,
    y: 308.6,
    width: 58.9,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st12",
    x: 243.1,
    y: 312,
    width: 58.9,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st12",
    x: 243.1,
    y: 315.5,
    width: 58.9,
    height: 2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M312.7,303.6c0,1.1-.9,2-2,2s-2-.9-2-2,.9-2,2-2,2,.9,2,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M319.3,303.6c0,1.1-.9,2-2,2s-2-.9-2-2,.9-2,2-2,2,.9,2,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M325.9,303.6c0,1.1-.9,2-2,2s-2-.9-2-2,.9-2,2-2,2,.9,2,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M332.5,303.6c0,1.1-.9,2-2,2s-2-.9-2-2,.9-2,2-2,2,.9,2,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M339.1,303.6c0,1.1-.9,2-2,2s-2-.9-2-2,.9-2,2-2,2,.9,2,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M312.7,309.6c0,1.1-.9,2-2,2s-2-.9-2-2,.9-2,2-2,2,.9,2,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M319.3,309.6c0,1.1-.9,2-2,2s-2-.9-2-2,.9-2,2-2,2,.9,2,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M325.9,309.6c0,1.1-.9,2-2,2s-2-.9-2-2,.9-2,2-2,2,.9,2,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M332.5,309.6c0,1.1-.9,2-2,2s-2-.9-2-2,.9-2,2-2,2,.9,2,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M339.1,309.6c0,1.1-.9,2-2,2s-2-.9-2-2,.9-2,2-2,2,.9,2,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M312.7,315.6c0,1.1-.9,2-2,2s-2-.9-2-2,.9-2,2-2,2,.9,2,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M319.3,315.6c0,1.1-.9,2-2,2s-2-.9-2-2,.9-2,2-2,2,.9,2,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M325.9,315.6c0,1.1-.9,2-2,2s-2-.9-2-2,.9-2,2-2,2,.9,2,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M332.5,315.6c0,1.1-.9,2-2,2s-2-.9-2-2,.9-2,2-2,2,.9,2,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M339.1,315.6c0,1.1-.9,2-2,2s-2-.9-2-2,.9-2,2-2,2,.9,2,2Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st7",
    x: 304.9,
    y: 301.6,
    width: 1.1,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st6",
    x: 238.8,
    y: 268.8,
    width: 103.5,
    height: 23.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st12",
    x: 243.1,
    y: 272.8,
    width: 58.9,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st12",
    x: 243.1,
    y: 276.3,
    width: 58.9,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st12",
    x: 243.1,
    y: 279.8,
    width: 58.9,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st12",
    x: 243.1,
    y: 283.2,
    width: 58.9,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st12",
    x: 243.1,
    y: 286.8,
    width: 58.9,
    height: 2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M312.7,274.8c0,1.1-.9,2-2,2s-2-.9-2-2,.9-2,2-2,2,.9,2,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M319.3,274.8c0,1.1-.9,2-2,2s-2-.9-2-2,.9-2,2-2,2,.9,2,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M325.9,274.8c0,1.1-.9,2-2,2s-2-.9-2-2,.9-2,2-2,2,.9,2,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M332.5,274.8c0,1.1-.9,2-2,2s-2-.9-2-2,.9-2,2-2,2,.9,2,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M339.1,274.8c0,1.1-.9,2-2,2s-2-.9-2-2,.9-2,2-2,2,.9,2,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M312.7,280.8c0,1.1-.9,2-2,2s-2-.9-2-2,.9-2,2-2,2,.9,2,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M319.3,280.8c0,1.1-.9,2-2,2s-2-.9-2-2,.9-2,2-2,2,.9,2,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M325.9,280.8c0,1.1-.9,2-2,2s-2-.9-2-2,.9-2,2-2,2,.9,2,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M332.5,280.8c0,1.1-.9,2-2,2s-2-.9-2-2,.9-2,2-2,2,.9,2,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M339.1,280.8c0,1.1-.9,2-2,2s-2-.9-2-2,.9-2,2-2,2,.9,2,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M312.7,286.8c0,1.1-.9,2-2,2s-2-.9-2-2,.9-2,2-2,2,.9,2,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M319.3,286.8c0,1.1-.9,2-2,2s-2-.9-2-2,.9-2,2-2,2,.9,2,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M325.9,286.8c0,1.1-.9,2-2,2s-2-.9-2-2,.9-2,2-2,2,.9,2,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M332.5,286.8c0,1.1-.9,2-2,2s-2-.9-2-2,.9-2,2-2,2,.9,2,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M339.1,286.8c0,1.1-.9,2-2,2s-2-.9-2-2,.9-2,2-2,2,.9,2,2Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st7",
    x: 304.9,
    y: 272.8,
    width: 1.1,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st12",
    x: 238.8,
    y: 211.2,
    width: 103.5,
    height: 23.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st10",
    x: 248.4,
    y: 220.5,
    width: 52.5,
    height: 5.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st11",
    x: 248.4,
    y: 220.5,
    width: 32.2,
    height: 5.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M313.6,223.2c0,1.5-1.2,2.8-2.8,2.8s-2.8-1.2-2.8-2.8,1.2-2.8,2.8-2.8h0c1.5,0,2.8,1.2,2.8,2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M324.3,223.2c0,1.5-1.2,2.8-2.8,2.8s-2.8-1.2-2.8-2.8,1.2-2.8,2.8-2.8h0c1.5,0,2.8,1.2,2.8,2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M334.9,223.2c0,1.5-1.2,2.8-2.8,2.8-1.5,0-2.8-1.2-2.8-2.8s1.2-2.8,2.8-2.8c0,0,0,0,0,0,1.5,0,2.8,1.2,2.8,2.8Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st12",
    x: 238.8,
    y: 240,
    width: 103.5,
    height: 23.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st10",
    x: 248.4,
    y: 249.3,
    width: 52.5,
    height: 5.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st11",
    x: 248.4,
    y: 249.3,
    width: 42.1,
    height: 5.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M313.6,252c0,1.5-1.2,2.8-2.8,2.8s-2.8-1.2-2.8-2.8,1.2-2.8,2.8-2.8h0c1.5,0,2.8,1.2,2.8,2.8,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M324.3,252c0,1.5-1.2,2.8-2.8,2.8s-2.8-1.2-2.8-2.8,1.2-2.8,2.8-2.8h0c1.5,0,2.8,1.2,2.8,2.8,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M334.9,252c0,1.5-1.2,2.8-2.8,2.8-1.5,0-2.8-1.2-2.8-2.8s1.2-2.8,2.8-2.8c0,0,0,0,0,0,1.5,0,2.8,1.2,2.8,2.8,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st12",
    x: 238.8,
    y: 268.8,
    width: 103.5,
    height: 23.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st10",
    x: 248.4,
    y: 278.1,
    width: 52.5,
    height: 5.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st11",
    x: 248.4,
    y: 278.1,
    width: 8.8,
    height: 5.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M313.6,280.8c0,1.5-1.2,2.8-2.8,2.8s-2.8-1.2-2.8-2.8,1.2-2.8,2.8-2.8h0c1.5,0,2.8,1.2,2.8,2.8,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M324.3,280.8c0,1.5-1.2,2.8-2.8,2.8-1.5,0-2.8-1.2-2.8-2.8s1.2-2.8,2.8-2.8c0,0,0,0,0,0,1.5,0,2.8,1.2,2.8,2.8,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M334.9,280.8c0,1.5-1.2,2.8-2.8,2.8-1.5,0-2.8-1.2-2.8-2.8s1.2-2.8,2.8-2.8,0,0,0,0c1.5,0,2.8,1.2,2.8,2.8,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st12",
    x: 238.8,
    y: 297.6,
    width: 103.5,
    height: 23.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st10",
    x: 248.4,
    y: 306.9,
    width: 52.5,
    height: 5.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st11",
    x: 248.4,
    y: 306.9,
    width: 32.2,
    height: 5.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M313.6,309.6c0,1.5-1.2,2.8-2.8,2.8-1.5,0-2.8-1.2-2.8-2.8s1.2-2.8,2.8-2.8c0,0,0,0,0,0,1.5,0,2.8,1.2,2.8,2.8,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M324.3,309.6c0,1.5-1.2,2.8-2.8,2.8-1.5,0-2.8-1.2-2.8-2.8s1.2-2.8,2.8-2.8c0,0,0,0,0,0,1.5,0,2.8,1.2,2.8,2.8,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M334.9,309.6c0,1.5-1.2,2.8-2.8,2.8s-2.8-1.2-2.8-2.8,1.2-2.8,2.8-2.8c0,0,0,0,0,0,1.5,0,2.8,1.2,2.8,2.8Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st12",
    x: 238.8,
    y: 326.4,
    width: 103.5,
    height: 23.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st10",
    x: 248.4,
    y: 335.7,
    width: 52.5,
    height: 5.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st11",
    x: 248.4,
    y: 335.7,
    width: 43.7,
    height: 5.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M313.6,338.4c0,1.5-1.2,2.8-2.8,2.8-1.5,0-2.8-1.2-2.8-2.8s1.2-2.8,2.8-2.8c0,0,0,0,0,0,1.5,0,2.8,1.2,2.8,2.8,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M324.3,338.4c0,1.5-1.2,2.8-2.8,2.8-1.5,0-2.8-1.2-2.8-2.8s1.2-2.8,2.8-2.8c0,0,0,0,0,0,1.5,0,2.8,1.2,2.8,2.8,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M334.9,338.4c0,1.5-1.2,2.8-2.8,2.8s-2.8-1.2-2.8-2.8,1.2-2.8,2.8-2.8c0,0,0,0,0,0,1.5,0,2.8,1.2,2.8,2.8Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st12",
    x: 238.8,
    y: 355.2,
    width: 103.5,
    height: 23.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st10",
    x: 248.4,
    y: 364.5,
    width: 52.5,
    height: 5.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st11",
    x: 248.4,
    y: 364.5,
    width: 35.9,
    height: 5.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M313.6,367.2c0,1.5-1.2,2.8-2.8,2.8s-2.8-1.2-2.8-2.8,1.2-2.8,2.8-2.8h0c1.5,0,2.8,1.2,2.8,2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M324.3,367.2c0,1.5-1.2,2.8-2.8,2.8s-2.8-1.2-2.8-2.8,1.2-2.8,2.8-2.8h0c1.5,0,2.8,1.2,2.8,2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M334.9,367.2c0,1.5-1.2,2.8-2.8,2.8-1.5,0-2.8-1.2-2.8-2.8s1.2-2.8,2.8-2.8,0,0,0,0c1.5,0,2.8,1.2,2.8,2.8Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st12",
    x: 238.8,
    y: 384,
    width: 103.5,
    height: 23.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st10",
    x: 248.4,
    y: 393.3,
    width: 52.5,
    height: 5.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st11",
    x: 248.4,
    y: 393.3,
    width: 19,
    height: 5.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M313.6,396c0,1.5-1.2,2.8-2.8,2.8s-2.8-1.2-2.8-2.8,1.2-2.8,2.8-2.8h0c1.5,0,2.8,1.2,2.8,2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M324.3,396c0,1.5-1.2,2.8-2.8,2.8s-2.8-1.2-2.8-2.8,1.2-2.8,2.8-2.8h0c1.5,0,2.8,1.2,2.8,2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M334.9,396c0,1.5-1.2,2.8-2.8,2.8-1.5,0-2.8-1.2-2.8-2.8s1.2-2.8,2.8-2.8,0,0,0,0c1.5,0,2.8,1.2,2.8,2.8Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st12",
    x: 238.8,
    y: 412.8,
    width: 103.5,
    height: 23.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st10",
    x: 248.4,
    y: 422.1,
    width: 52.5,
    height: 5.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st11",
    x: 248.4,
    y: 422.1,
    width: 37.2,
    height: 5.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M313.6,424.8c0,1.5-1.2,2.8-2.8,2.8s-2.8-1.2-2.8-2.8,1.2-2.8,2.8-2.8h0c1.5,0,2.8,1.2,2.8,2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M324.3,424.8c0,1.5-1.2,2.8-2.8,2.8-1.5,0-2.8-1.2-2.8-2.8,0-1.5,1.2-2.8,2.8-2.8,0,0,0,0,0,0,1.5,0,2.8,1.2,2.8,2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M334.9,424.8c0,1.5-1.2,2.8-2.8,2.8-1.5,0-2.8-1.2-2.8-2.8s1.2-2.8,2.8-2.8,0,0,0,0c1.5,0,2.8,1.2,2.8,2.8Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 188.9,
    y: 191.3,
    width: 136.4,
    height: 7.6
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Folder--inject-18"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "348.3 444.7 442 444.7 431.8 379.9 338 379.9 348.3 444.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "397.6 373.1 430.7 373.1 431.8 379.9 396.7 379.9 397.6 373.1"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "348.3 444.7 442 444.7 431.8 379.9 338 379.9 348.3 444.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "397.6 373.1 430.7 373.1 431.8 379.9 396.7 379.9 397.6 373.1"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "348.2 444.7 442 444.7 449.2 385.2 355.5 385.2 348.2 444.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "416.9 379.1 450 379.1 449.2 385.2 414.2 385.2 416.9 379.1"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M94,444.5c2.3.7,68.7.1,71.2-1.5.9-.6-4-63.6-4-63.6l-42.3.3,4.4,42.1s-24.7,11.3-27.2,13.3-4.4,8.5-2.1,9.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M94,444.5c2.3.7,68.7.1,71.1-1.5.3-.2.5-6.6-.5-14.9-12.1,1.9-55.2,7.9-58.5,5.9-2.3-1.4-.2-3.5,1.7-4.9-5.5,2.7-10.7,5.2-11.7,6.1-2.5,2-4.4,8.5-2.2,9.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M126.5,444.7c18.1-.2,37.4-.8,38.7-1.6.3-.2.5-6.6-.5-14.9-4,.6-11.4,1.7-19.7,2.8l-18.4,13.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M120,411.8h46.6s-8.8-99.2-8.4-101.1c.5-2.4,3.2-13.4,6.9-27.8,1.1-4.5,2.4-9.3,3.7-14.3,3.5-13.5,7.3-28.3,10.6-41.2,5-19.3,8.9-34.3,8.9-34.3h-39.5s-4.6,14.6-10.4,33.6c-9.4,30.8-22.1,73.3-23.3,83.6-2,16.7,4.9,101.5,4.9,101.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M122.1,403.8c7.1-.1,5.1-.2,12.2-.3,3.5,0,26.4-.2,29.6.3,0,0,0,0,0,.1,0,0,0,0,0,0-3.2.5-26.1.3-29.6.3-7.1,0-5.1-.1-12.2-.3,0,0,0-.2,0-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M149.4,304c1.5-6.7,3.8-13.3,5.8-19.9,4-13.4,8.1-26.9,12.2-40.3,2-6.7,4.1-13.4,6.1-20.1,1-3.4,2.1-6.8,3.1-10.1,1-3.3,2.2-6.6,3.1-9.9.4-1.4.6-.6.1,1.1-1,3.5-1.9,7-3,10.4-2,6.9-4,13.7-6.1,20.6-4,13.7-8.1,27.3-12.2,40.9-2.1,6.8-4.1,13.7-6.2,20.5-1,3.2-1.9,6.6-2.5,9.9-.6,3.5-.7,7.1-.4,10.6.4,7.1,1.3,14.2,1.9,21.4s1.3,14.2,2,21.4c1.3,14.2,2,18.7,3.3,32.9.2,1.8.3,3.6.4,5.4,0,.6-.9.6-.9,0-1.5-14-2.1-18.5-3.4-32.5l-3.9-41.9c-.3-3.5-.7-7-.7-10.5,0-3.3.4-6.5,1.1-9.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M153.3,193.1c2.7,21.2,8,61,11.8,89.8,8.9-35,23.2-89.8,23.2-89.8h-35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M140.1,445.3c2.3.7,68.7.1,71.2-1.5.9-.6-1-63.6-1-63.6l-42.3.3,1.5,42.1s-24.7,11.3-27.2,13.3-4.4,8.5-2.2,9.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M140.1,445.3c2.3.7,68.7.1,71.2-1.5.3-.2.3-6.4.2-14.9-12.1,1.9-55.8,7.9-59.1,5.9-2.3-1.4-.2-3.5,1.7-4.9-5.5,2.7-10.7,5.2-11.8,6.1-2.5,2-4.4,8.5-2.2,9.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M150.1,193.1s.9,18.9,5.2,33.9c.4,1.2.7,2.4,1.1,3.6,4,1.6,7.8,3.6,11.4,5.9,0,0,.4,15.2.9,32.1.5,19-2.4,40.1-2.5,44.6-.4,16.8,1.6,98.5,1.6,98.5l46.6.2s-8-92.5-7.9-98.6c0-9.9-3.4-78.6-2.8-80.1,7.5-19.6-2.4-40-2.4-40h-51.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M169.4,403.3c7.1-.1,5.1-.2,12.2-.2,3.5,0,26.4-.1,29.6.4,0,0,0,0,0,0s0,0,0,0c-3.3.5-26.1.2-29.6.2-7.1-.1-5.1-.1-12.2-.3,0,0-.1,0-.2,0,0,0,0-.1,0-.2,0,0,.1,0,.2,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M154.5,229.4c4.6,1.9,9.1,4.3,13.3,7,0,0,.1.1,0,.2,0,0-.1,0-.2,0-4.5-2.2-9.1-4.3-13.4-6.7-.2,0-.2-.3-.1-.4,0-.2.3-.2.4-.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M161.5,223.1c-.1-2.1-.3-4.3-.5-6.4-.4-4.9-.9-9.7-1.8-14.5,0-.4-.6-.2-.6.1.3,3.8.8,7.5,1.1,11.3s.8,7.5.9,11.3c0,1.1,0,3.1-1.4,3.4-1.9.4-2.7-2-3.2-3.4-1.1-3.4-1.9-6.8-2.3-10.3-.6-4-.9-8-1.3-11.9,0-.1-.2-.1-.2,0,0,7.9,0,16.2,3,23.6.6,1.4,1.6,2.9,3.3,3.1h0s0,0,0,.1c0,.2,0,.4.1.7s0,.4.1.6c0,.4.1.8.2,1.1,0,.2.2.3.3.3.2,0,.3-.2.3-.3,0,0,.2-.1.2-.2,0-.8-.2-1.5-.5-2.2.9-.2,1.7-.8,2-1.7.7-1.4.5-3.1.4-4.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M199,233c.5-3.3,1.2-6.5,2-9.7,1.7-7.2.6-17.1-1.3-24.1,0-.2.3-.3.3,0,1.9,6,3.2,14.7,2.5,21-.3,3-2.8,12.1-2.7,15.4.1,6.4-.4,61.3,0,83.6.3,14.7,3.3,64,3.8,78.6,0,.1-.2.1-.2,0-1.7-26.2-3.9-52.9-4.3-78.6-.3-24.9-.6-82.6-.2-86.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M176,200.8c.2,2.2.3,4.5.6,6.8.2,2.1,1.1,4,2.5,5.5,1.5,1.4,3.3,2.4,5.2,3,2.6.8,10.3.8,13,.4.7,0,.6.4-.6.7-2.8.4-5.7.6-8.6.6-1.4,0-2.8,0-4.2-.3-2.3-.4-4.4-1.5-6.1-3.2-1.5-1.7-2.4-3.9-2.5-6.1-.2-2.5,0-4.9.3-7.4,0-.2.3-.2.3,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M203.7,113.4c.7,3.7,1.5,7.3,2.1,11,.4,2.2.6,4.5.8,6.8-.6.9-1.4,1.8-2.2,2.5,0-.6,0-1.1-.1-1.7-.2-2.7-.6-5.3-1-8,0,0-.1,0-.1,0,.4,2.8.5,5.6.7,8.4v1.8c-.8.7-1.6,1.3-2.5,1.8,0-.7,0-1.3,0-2,0-1.5-.1-3.1-.3-4.6-.3-3-.7-6-1.3-9,0-.1-.2,0-.2,0,.4,3.1.7,6.2.9,9.3.1,1.5.2,3,.2,4.4v2.1c-1.6.9-3.3,1.7-5,2.3-4.9,1.8-10.4,1.7-15.5.9-4.5-.7-8.8-2.4-12.5-5.2,1.1-2.4,2-5,2.4-7.7,0,0,0-.1-.1,0-.5,1.7-1.1,3.4-1.8,5-.3.8-.7,1.5-1,2.3h-.2c-.4-.4-.7-.8-1.1-1.1.6-1.6,1.2-3.2,1.7-4.8.7-2.3,1.3-4.6,1.6-7,0-.2-.2-.2-.2,0-.7,2.2-1.3,4.5-2,6.7-.5,1.6-1.1,3.1-1.6,4.7-1.2-1.1-2-2.6-2.1-4.2,0-1.4.4-2.7.9-4,.5-1.4.9-2.9,1.2-4.4.7-3.1,1.1-6.3,1.2-9.5.1-3-.2-6,0-8.9,0-2.5.8-4.8,2.3-6.8,1.3-1.5,2.9-2.5,4.7-3.1,0,0,8.4-9.2,20.1-4.4,9.6,3.9,15,34,15,37,0,2.2-.6,4.4-1.6,6.4-.1-1.9-.4-3.8-.7-5.7-.6-3.8-1.6-7.5-2.6-11.2,0-.1-.1,0-.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M182,139.3c-17.8,15.8-37.5,26.5-44.8,23.6s-23.5-29.6-24.3-37.7c-.3-3.5,19.7-17.6,21.7-14.4,2.4,3.7,11.4,26,13,27.6,1.2,1.2,17.8-5.8,30.4-9.6,8.1-2.4,13.4,2.2,4,10.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M166,154l-2.6-20.9c5.1-2,10.3-3.7,15.6-5.1,7.6-1.8,11.6.6,6,8.4-3.7,5.2-19,17.6-19,17.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M165.5,132.3c-.2.5-.3,1.1-.3,1.6.4-.6.8-1.2,1-1.9l-.7.3ZM183.8,137.1c-.3-.8-.8-1.5-1.3-2.1.1.8.4,1.6.7,2.4.1.3.2.5.4.8.1-.2.3-.3.4-.5,0-.2-.2-.4-.2-.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M167.7,151.6c-.2-3.1-.4-6.1-.7-9.2-.2-1.5-.4-3-.6-4.6s-.6-3-.8-4.5c0,0-.1,0-.1,0,.3,1.5.4,3,.6,4.6s.4,3,.6,4.6c.4,3,.7,6.1,1,9.1,0,.1.1,0,.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M185.1,136.4c-3.8,5.2-19,17.6-19,17.6l-1.8-14.6,22.6-11c1.5,1.3,1.2,3.9-1.7,8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M103.4,114.4c2.3,5.1,11.2,13.6,14.1,14.8s17.9-13.3,17.6-16.5-9.5-19.8-14.6-22.3-19.4,18.7-17,24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M134,109.7c-.2-4.5.2-9,1.3-13.4,1.5-5.2,4.3-12.7,1.5-13.6-5.6-1.8-12.6,16.9-12.6,16.9,0,0-1.7,8.8,3.7,11.1,2,.8,4.4.5,6-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M127.5,96c-.3,2.9-3.6.9-3.6.9,0,0,4,4.1,2.5,7s-5.3.1-5.6,0c.2.2,3.8,4.1,2,6.9s-5.3-.5-5.6-.7c.1.3,1.8,3.9,0,5.7-3.2,3-7.8-6-11.2-7,0,0-2.3,5.7-2.4,5.8,0,0-4.5-8.6-2.9-13.1.5-1.4,1.8-2.3,3.2-2.1,0,0-1.8-2.6-.4-4.8.7-1.1,3.2-1,3.2-1-.7-1.2-.7-2.8,0-4,1.1-1.5,3.3-1.2,3.3-1.2,0,0-.3-2.6,1.3-3.8,3.1-2.5,17,5.3,16.3,11.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M110.2,88.2s0,0,0,0c5.4,1.5,10.2,4.6,13.8,8.8.1.1,0,.4-.2.2-4.1-3.6-8.6-6.7-13.6-9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M106.5,93.3c0,0,0-.1,0,0,5.9,1.7,11.1,5.4,14.5,10.6.1.2,0,.5-.1.3-2.5-3.4-9.8-8.6-14.4-10.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M117.2,110.5c-3.4-5-8-8.4-13.3-11.2,0,0,0-.1,0-.1,3,.7,6.1,2.8,8.4,4.7,2.2,1.7,3.9,3.9,5,6.5,0,.1,0,.2-.2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M124,96.8c.1.2-.3.2-.1.3.5.7,3.4,5.3,2.1,6.8-1,1.2-3.3.6-4.1,0l-2-1.4,1.4,2c.6.9,1.1,1.9,1.4,2.9.3,1,.3,2-.2,2.9-.4.9-1.4,1.3-2.4,1-1-.3-1.9-.9-2.6-1.7l-2-2.1,1.2,2.6c.3.7.6,1.5.7,2.3.2.7.1,1.5-.1,2.2-.3.6-.9,1.1-1.6,1.1-.8,0-1.5-.4-2.1-.8-1.3-1-2.6-2.1-3.8-3.3-.6-.6-1.2-1.2-1.9-1.7-.6-.6-1.3-1.1-2.1-1.3.8.4,1.4.9,2,1.5.6.6,1.2,1.2,1.7,1.8,1.1,1.3,2.3,2.5,3.7,3.6.7.6,1.6,1,2.5,1.1,1,0,2-.6,2.4-1.6.4-.9.4-1.8.2-2.8-.1-.9-.4-1.7-.8-2.5l-.8.5c.8.9,1.8,1.6,3,2,.7.2,1.4.2,2,0,.6-.3,1.1-.7,1.5-1.3.6-1.1.7-2.5.3-3.7-.4-1.1-.9-2.2-1.6-3.2l-.6.6c1,.7,3.5,1.6,5.3,0,2-2.5-1.9-7.1-2.7-7.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M123.9,96.8c.6.2,1.2.4,1.8.4.5,0,1-.2,1.3-.6.2-.5.3-1,.3-1.6,0-.6-.1-1.2-.2-1.9.4.5.7,1.1.8,1.8.2.7.1,1.5-.2,2.1-.2.3-.5.6-.9.7-.4.1-.7.1-1.1,0-.7-.2-1.3-.5-1.7-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M158.8,166.4l-11.9,29.9s43.1.9,56.4.8c0,0,8.3-48.5-5-64.7-6.6-8.1-12.4-7.7-18.1-2.6-1.4,1.3-20.3,15.6-22.4,23.6-1.1,4.3-.7,8.9,1,13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M168.2,164.9c2.7.3,5.4.7,8,1.4,1.3.4,2.6.8,3.9,1.2.6.2,1.3.4,1.9.6.7.2,1.4.4,2.1.4,0,0,0,0,0,0s0,0,0,0c-.7,0-1.3,0-2,0-.6,0-1.3-.2-1.9-.4-1.3-.3-2.6-.7-4-1.1-2.7-.7-5.3-1.4-8.1-1.9,0,0,0,0,0-.2,0,0,0,0,.2,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M161.5,167.2c2.2-.2,4.5-.3,6.7-.3,1.1,0,2.2.1,3.4.2.5,0,1.1.1,1.6.2s1.2.2,1.7.3c0,0,0,.1,0,.1-.6,0-1.1,0-1.7,0h-1.7c-1.1,0-2.2-.1-3.4-.2-2.2,0-4.5-.2-6.7-.2,0,0-.1,0-.1-.1,0,0,0-.1.1-.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M181.3,159c-.8-.3-1.6-.5-2.4-.6.7.5,1.4.9,2.2,1.2.8.3,1.6.5,2.4.6-.7-.5-1.4-.9-2.2-1.2ZM192.5,189.5c-.8-.3-1.6-.5-2.4-.6.7.5,1.4.9,2.2,1.1.8.3,1.6.5,2.4.6-.7-.5-1.4-.9-2.2-1.1h0ZM162.8,145.5c0,0-.1.1-.2.2.2,0,.4,0,.6,0-.1-.1-.3-.2-.4-.3h0ZM169.4,189.5c-.8-.3-1.6-.5-2.4-.5.7.5,1.4.9,2.2,1.1.8.3,1.6.5,2.4.6-.7-.5-1.4-.9-2.2-1.2h0ZM199.4,140.5c-.8-.3-1.6-.5-2.4-.5.7.5,1.4.9,2.2,1.2.8.3,1.6.5,2.4.6-.7-.5-1.4-.9-2.2-1.2h0ZM191.1,126.5c-.2.3-.3.7-.4,1-.3.8-.5,1.6-.6,2.4.5-.7.9-1.4,1.1-2.2.1-.3.2-.7.3-1-.2,0-.3-.2-.5-.2h0ZM181.1,179.7c-.3.8-.5,1.6-.5,2.4.5-.7.9-1.4,1.1-2.2.3-.8.5-1.6.6-2.4-.5.7-.9,1.4-1.1,2.2h0ZM192,151.6c-.3.8-.5,1.6-.6,2.4.5-.7.9-1.4,1.2-2.2.3-.8.5-1.6.6-2.4-.5.7-.9,1.4-1.2,2.2ZM157.1,196.5h.5c0-.3.1-.7.1-1.1-.2.3-.4.7-.6,1.1h0ZM200.3,179.5c-.8.3-1.5.8-2.1,1.3.8-.1,1.6-.4,2.4-.7.8-.3,1.5-.8,2.1-1.3-.8.1-1.6.4-2.3.8h0ZM168.9,174.7c-.8.3-1.5.8-2.1,1.3,1.6-.3,3.2-1,4.5-2.1-.8.1-1.6.4-2.3.8h0ZM175.6,147.5c-.8.3-1.5.8-2.1,1.3.8-.1,1.6-.4,2.4-.7.8-.3,1.5-.8,2.1-1.3-.8.1-1.6.4-2.3.8h0ZM181.7,195.4c0,.5.2.9.4,1.4h.6c-.3-.5-.6-.9-.9-1.4h0ZM155.5,182.4c-.3-.8-.8-1.5-1.3-2.1.1.8.4,1.6.7,2.4.3.8.8,1.5,1.3,2.1-.1-.8-.4-1.6-.7-2.3h0ZM166.3,160.5c-.3-.8-.8-1.5-1.3-2.1.1.8.4,1.6.7,2.4.3.8.8,1.5,1.3,2.1-.1-.8-.4-1.6-.7-2.3h0ZM192.3,167.9c-.3-.8-.8-1.5-1.3-2.1.1.8.4,1.6.7,2.4.3.8.8,1.5,1.3,2.1-.1-.8-.4-1.6-.7-2.3h0ZM183.8,137.1c-.3-.8-.8-1.5-1.3-2.1.1.8.4,1.6.7,2.4.3.8.8,1.5,1.3,2.1-.1-.8-.4-1.6-.7-2.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M206.8,139.5c10,12.1,20.9,33.9,17.7,45-3.1,10.7-50.7,9.2-58.8,8.1-3.5-.5.5-24.6,4.2-24.3,6.2.4,31.6-1.7,32-1.7,0,0-3.9-11.4-6.8-23.8-3.9-16.9,4.6-11.8,11.6-3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M201.7,166.3c1.9.5,3.8,1.2,5.6,2.2,1.8.9,3.4,2.1,4.8,3.5-1.8-1-3.4-1.9-5.2-2.9s-3.4-1.9-5.2-2.8Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st8",
    x: 156.3,
    y: 180.1,
    width: 61.5,
    height: 2.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st9",
    x: 156.3,
    y: 180.1,
    width: 30.9,
    height: 2.8
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "183.9 182.8 124 182.8 116.1 142.1 176.1 142.1 183.9 182.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M153.7,162.5c.2,1.8-1.1,3.4-2.9,3.6-.1,0-.3,0-.4,0-2.1,0-3.8-1.6-4-3.6-.2-1.8,1.1-3.4,2.9-3.6.1,0,.3,0,.4,0,2.1,0,3.8,1.6,4,3.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M176.9,185.1c-4.1,2-9,7.1-12.4,7.6-1.7.3-3.4-.5-4.1-2.1,0,0-1.6,3.4-4.7,3.3-1.6,0-2.9-2.6-2.9-2.6,0,0-1.4,2.6-4.1,2.4-2.2-.2-3.2-2.8-3.2-2.8,0,0-2.5,1.9-4.7,1-4.4-1.8-4.9-20.8,2.1-23.8,3.2-1.4,3.1,3.2,3.1,3.2,0,0,1.8-6.6,5.7-6.8s3.4,5.8,3.4,5.8c0,0,1.8-6.4,5.9-6.2,4.2.2,2.6,6.1,2.6,6.1,0,0,2.8-4.3,5.8-3.4,5.1,1.4-1,11.1,0,15.3l6.8.2.9,2.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M171.1,188.6c4-1.6,5.8,1.3,10,.9,4.6-.5,3.3-5.9-4.8-7.1l-7-.2,1.8,6.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M145.1,190.6c0,0,0,0-.1,0-1.7-6.4-1.5-13.2.7-19.5,0-.2.4-.2.4,0-1.3,6.4-1.6,12.9-1,19.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M152.7,191.4c0,0-.1,0-.1,0-1.7-6.4-1.4-14.6,2.1-21.2.1-.2.4-.3.3,0-2,4.6-3,15.2-2.3,21.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M163.8,169.9c-3.1,6.5-3.8,13.3-3.5,20.4,0,.1-.1,0-.1,0-1.1-3.4-.8-8-.3-11.5.4-3.3,1.7-6.4,3.7-9,0-.1.3,0,.2,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M165.3,192.5c1.2-.5,2.3-1.1,3.4-1.8,1.1-.7,2-1.6,3.1-2.3.3-.2.6-.3.9-.4.4,0,.7,0,1.1,0,.6.1,1.3.3,1.9.4,1.2.4,2.5.6,3.7.8,1.2.1,2.6.1,3.3-.7.4-.4.6-.9.6-1.5,0-.6-.2-1.1-.6-1.5-.9-.9-1.9-1.6-3.1-2.1-1.2-.5-2.4-.9-3.7-1.1,1.3,0,2.6.2,3.8.7,1.3.4,2.4,1.1,3.4,2,1.1,1.1,1.1,2.8,0,3.9-.5.5-1.2.9-1.9.9-.7,0-1.3,0-2,0-1.3-.2-2.6-.5-3.8-.9-.6-.2-1.2-.4-1.8-.5-.3,0-.6-.1-.9,0-.3,0-.6.2-.8.4-2.1,1.3-4.2,3.1-6.7,3.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M218.6,153.3l-21.7.8c-1.6-5.4-2.8-11-3.8-16.6-1.1-8,1.6-10.3,9.1-3.8,5,4.4,16.5,19.6,16.5,19.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M209.9,151.7c-.9-.2-1.8-.4-2.6-.8-.8-.4-1.6-.8-2.3-1.4,1.8.4,3.4,1.1,4.9,2.2ZM204.6,136.2c-1.7.3-3.3.9-4.7,1.9.9-.1,1.8-.3,2.6-.7.8-.3,1.5-.6,2.2-1.1h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M199,154c-.7,0-1.4,0-2.1,0-.3-1.2-.6-2.5-1-3.7-.2-.6-.4-1.2-.5-1.9s-.4-1.5-.6-2.1c0,0-.1,0-.1,0,.2.8.3,1.4.4,2.1,0,.5.2,1,.3,1.5l-.2-.4c-.3-.6-.7-1.2-1-1.9,0,0-.2,0-.1,0,.3.6.5,1.3.8,1.9.2.5.4,1,.7,1.4.2,1.1.4,2.3.7,3.3.9,0,1.7-.2,2.6-.3,0,0,.1,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M216.3,151.4c-3.2-.1-6.3-.2-9.5,0-1.6,0-7.9.5-9.5.6,0,0,0,.1,0,.1,2,.1,8.2-.1,9.8-.1,3.2,0,6-.3,9.2-.4.1,0,0-.1,0-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M193.2,132.2c-.5.9-7.2,6.1-11.7,4.6-1.5-.5.9-8.7.9-8.7v-.6l.5-9,11.8-3.6,1.7-.4s-.3,2.5-.7,5.5v.4c0,.2,0,.3,0,.5l-.2,1.4c0,.4-.1.7-.2,1.1s-.1.7-.2,1.1c-.4,2.6-1,5.2-1.8,7.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M196.4,114.4s-.3,2.5-.7,5.5v.4c0,.2,0,.3,0,.5l-.2,1.4c0,.4-.1.7-.2,1.1s-.1.7-.2,1.1c-.2,1.2-.4,2.3-.7,3.4-6.6,0-10.7-4.7-11.7-6l.2-3.3,11.8-3.6,1.6-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M204.4,105.9c1.2,15.8-8.1,18.3-11.6,18.6-3.1.2-13.7.6-16.5-15s4.1-21.2,11.2-22.1,15.7,2.7,16.9,18.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M201,102.2c-.4,0-.7,0-1.1-.2-.4,0-.8-.1-1.1-.4-.2-.2-.2-.5,0-.7.3-.4.9-.5,1.4-.4.5,0,1,.3,1.4.6.2.3.2.6,0,.9-.1,0-.3.1-.4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M190.5,104c.4,0,.7-.2,1.1-.3.4,0,.7-.2,1-.5.2-.2.2-.5,0-.7-.4-.3-.9-.5-1.4-.3-.5,0-1,.4-1.3.8-.2.3-.1.7.2.8.1,0,.3.1.4,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M193.1,106.8s0,0,0,.1c.1,1.1,0,2.3-.9,2.8M192.1,109.7c1.2-.2,1.3-1.9,1-2.9l-1,2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M192,105.7c-1.8,0-1.7,3.5,0,3.5s1.5-3.5,0-3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M191.4,105.9c-.3.2-.6.6-1,.6s-.8-.3-1-.7h0c0,.7.3,1.4,1,1.4s1.1-.5,1.3-1.2c0-.1-.1-.3-.2-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M199.4,106s0,0,0,0c0,1.1.2,2.3,1.2,2.7M200.7,108.8c-1.2,0-1.5-1.8-1.3-2.8l1.3,2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M200.3,104.8c1.8-.2,2,3.3.4,3.5s-1.9-3.3-.4-3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M201.1,105c.3.2.6.5.9.5s.6-.4.9-.8h0c0,.7,0,1.4-.7,1.6s-1.1-.4-1.3-1c0-.1,0-.3.2-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M193,115.3c.3.3.5.6.9.7.4,0,.8,0,1.2-.2M195.1,115.8c-.3.4-.9.6-1.4.6-.5-.1-.8-.5-.8-1,0,0,0,0,0,0s0,0,0,0l2.1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M197.9,111s.3,1.6.3,2.4c-1.5.4-3,0-4.1-1.1,0,0,0-.2.1-.1,1,.6,2.2.9,3.4.8,0-.2-.6-2.8-.5-2.8.6,0,1.2.1,1.8.3-.5-3.4-1.5-6.7-2-10.1,0,0,0-.1.1-.1,0,0,0,0,0,0,1.2,3.5,2.1,7.1,2.6,10.8.1.4-1.5,0-1.8-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M177.3,111.1c3,.3,3.6-6.7,3.6-6.7,0,0,12.8-2.6,13.6-13.1,1.8,4.2,5.1,7.6,9.2,9.4,0,0-.8-11.5-10-13.4,0,0-11.4-3.8-17.5,5.4s-1,18.2,1.1,18.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M194.5,90.6c.2,1.6,0,3.2-.4,4.8-.5,1.6-1.2,3-2.3,4.3-.3.3-.5.6-.8.9l-.4.4c-.1.1-.3.3-.5.4s-.6.5-1,.7l-1.1.6c-.2,0-.4.2-.5.3l-.6.2-1.1.5c-.8.2-1.6.4-2.3.6.7-.3,1.5-.6,2.2-1l1.1-.6.5-.3c.2,0,.3-.2.5-.3l1-.7c.3-.2.6-.5.9-.8l.4-.4.4-.4c.3-.3.5-.6.8-.9,1.5-1.8,2.5-4,3-6.3.2-.8.3-1.5.3-2.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M179,110.6s-3.4-5-5.7-3.8.3,8.4,2.9,9.4c1.4.6,3,0,3.6-1.3,0,0,0,0,0,0l-.8-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M174.1,108.8s0,0,0,0c1.9.8,2.8,2.5,3.5,4.3-.4-.7-1.3-1-2-.6,0,0-.1,0-.2.1,0,0,0,.1,0,0,.7-.2,1.4,0,1.8.6.3.5.6,1,.9,1.5,0,.2.4,0,.3-.1h0c0-2.4-1.8-5.7-4.3-6Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroImage);
export default __webpack_public_path__ + "static/media/hero-image.b9ef310d26cfe9614141ee2fb1af6dd8.svg";
export { ForwardRef as ReactComponent };